import { render } from "./addPoints.vue?vue&type=template&id=11ca1c0e&scoped=true"
import script from "./addPoints.vue?vue&type=script&lang=js"
export * from "./addPoints.vue?vue&type=script&lang=js"

import "./addPoints.vue?vue&type=style&index=0&id=11ca1c0e&lang=scss"
import "./addPoints.vue?vue&type=style&index=1&id=11ca1c0e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ca1c0e"],['__file',"src/views/marketing/components/addPoints.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11ca1c0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11ca1c0e', __exports__)) {
    console.log('reload')
    api.reload('11ca1c0e', __exports__)
  }
  
  module.hot.accept("./addPoints.vue?vue&type=template&id=11ca1c0e&scoped=true", () => {
    console.log('re-render')
    api.rerender('11ca1c0e', render)
  })

}


export default __exports__